// extracted by mini-css-extract-plugin
export default {"form":"Input_form__9fZoj","input":"Input_input__cKBr9","btn":"Input_btn__TLGzN"};